/* === 权限相关 START === */

// 更新用户信息
export const UPDATE_MEMBERINFO = 'UPDATE_MEMBERINFO'

// 更新用户权限
export const UPDATE_MEMBERPOWER = 'UPDATE_MEMBERPOWER'

// 更新菜单
export const UPDATE_MODULE = 'UPDATE_MODULE'

/* === 权限相关 END === */


// WEBPACK FOOTER //
// ./src/store/mutation-types.js